"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _upperFirst = _interopRequireDefault(require("./../_utils/upper-first"));
/**
 * This function extracts a color scale from the token helper returned by the
 * useTheme hook.
 */
var getColorScale = function getColorScale(t) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "categorical";
  return t.tokens["_themeColorScale" + (0, _upperFirst["default"])(name)];
};
var _default = getColorScale;
exports["default"] = _default;